import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseUrl } from './DemoModal'

function Pricing({ handleOpen }) {
    const [planData, setPlanData] = useState([])

    useEffect(() => {
        fetchPlans()
    }, [])
    const fetchPlans = async () => {
        try {
            const response = await axios.get(`${baseUrl}/public/plans`)
            // console.log(response);
            if (response.data?.success) {
                setPlanData(response?.data?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="features-choose-sections position-relative" id="pricing">
            <img src='/assets/img/vector/Group34.png' className='right-group34' />
            <div className="container">
                <div className="row ">
                    <div className="col-lg-6 col-12">
                        <div className="common-title-sections">
                            <h3>Best Pricing Plans</h3>
                        </div>
                        {/* <div className="feature-content-headings mb-5">
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna aliqua ad minim veniam.</p>
                </div> */}
                    </div>
                </div>
                <div className="row justify-content-start position-relative" style={{ zIndex: "5" }}>
                    {
                        planData?.length > 0 &&
                            planData?.map((item, index) => {
                                const pricePerMonth = parseFloat(item?.price) / 12
                                // console.log(pricePerMonth.toFixed(2));

                                return (
                                    // ${index == 1 ? "bg-pink" : index == 2 ? "plus-plan bg-warning text-dark" : ""} 
                                    <div key={index} className="col-lg-5 col-sm-6 col-12 d-flex">
                                        <div className={` 
                                            freeplan flex-fill`}>
                                            <div className="freeplan-set mb-1 p-1">
                                                <div className="card-body sv-freeplan  rounded mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div style={{ background: "#047EFF" }} className=" text-white p-2 rounded me-2 d-flex align-items-center justify-content-center" >
                                                            {Array.from({ length: index + 1 }).map((_, i) => (
                                                                <i key={i} className="fa fa-star me-1 text-warning"></i>
                                                            ))}

                                                        </div>
                                                        <h3 className="mb-0 fw-bold text-dark">{item?.name} </h3>
                                                    </div>
                                                    <hr />
                                                    <h2 style={{ fontSize: "40px" }} className="d-flex m-0 align-items-center fw-bold text-dark">
                                                        ₹{item?.price}
                                                        {
                                                            index == 1 ?
                                                                <small className='discount-title'> / year</small>
                                                                :
                                                                <small className='discount-title'>/ month</small>
                                                        }
                                                    </h2>
                                                    {
                                                        index == 1 &&
                                                        <small className='discount-title'> (₹{pricePerMonth.toFixed(2)} / month)</small>
                                                    }
                                                </div>
                                                <p>Include : </p>
                                                {
                                                    item?.features?.length > 0 ?
                                                        item?.features?.map((fea, index) => {
                                                            return (
                                                                <p key={index} className="pro-list">
                                                                    <i className='fa fa-tick' />
                                                                    {fea}
                                                                    </p>
                                                            )
                                                        }) :
                                                        <>
                                                            <p className="pro-list">Team limit - No Limit</p>
                                                        </>
                                                }
                                            </div>
                                            <div className="freeplan-btn">
                                                <a onClick={handleOpen} target="blank" className="btn btn-freeplanset">Get started</a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) 
                    //         <React.Fragment>
                    //             <div className="col-lg-4 col-sm-6 col-12 d-flex">
                    //                 <div className="freeplan flex-fill">
                    //                     <div className="freeplan-set mb-1 p-1">
                    //                         <div className="card-body sv-freeplan  rounded mb-3">
                    //                             <div className="d-flex align-items-center mb-2">
                    //                                 <div style={{ background: "#047EFF" }} className=" text-white p-2 rounded me-2 d-flex align-items-center justify-content-center" >
                    //                                     <i className='fa fa-star' />
                    //                                 </div>
                    //                                 <h3 className="mb-0 fw-bold">Monthly Plan</h3>
                    //                             </div>
                    //                             <hr />
                    //                             <h2 style={{ fontSize: "40px" }} className="fw-bold m-0 text-dark">₹100</h2>
                    //                         </div>
                    //                         <p>Include : </p>
                    //                         <p className="pro-list">Team limit - No Limit</p>
                    //                         <p className="pro-list">Admin Access - 1 Admin</p>
                    //                         <p className="pro-list">Features - All feature</p>
                    //                         <p className="pro-list">Invoice - ₹500/month Extra </p>
                    //                         <p className="pro-list">Manage Policy</p>
                    //                         <p className="pro-list">Manage Structure</p>
                    //                         <p className="pro-list">Plan Expiry Behavior- No Buffer</p>
                    //                     </div>
                    //                     <div className="freeplan-btn">
                    //                         <a onClick={handleOpen} target="blank" className="btn btn-freeplanset">Get started</a>
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //             <div className="col-lg-4 col-sm-6 col-12 d-flex">
                    //                 <div className="bg-pink freeplan plus-plan flex-fill">
                    //                     <div className="freeplan-set mb-1">
                    //                         <div className="card-body sv-freeplan  rounded mb-3">
                    //                             <div className="d-flex align-items-center mb-2">
                    //                                 <div style={{ background: "#047EFF" }} className=" text-white p-2 rounded me-2 d-flex align-items-center justify-content-center" >
                    //                                     <i className='fa fa-star' />
                    //                                     <i className='fa fa-star' />
                    //                                 </div>
                    //                                 <h3 className="mb-0 fw-bold text-dark">6 Month Plan</h3>
                    //                             </div>
                    //                             <hr className='text-dark' />
                    //                             <h2 style={{ fontSize: "40px" }} className="d-flex m-0 align-items-center fw-bold text-dark">₹300
                    //                                 <small className='discount-title'>(10% off)</small>
                    //                             </h2>
                    //                         </div>
                    //                         <p>Include : </p>
                    //                         <p className="pro-list">Team limit - No Limit</p>
                    //                         <p className="pro-list">Admin Access - 2 Admin</p>
                    //                         <p className="pro-list">Features - All feature</p>
                    //                         <p className="pro-list">Invoice - Additional Charges Apply </p>
                    //                         <p className="pro-list">Manage Policy</p>
                    //                         <p className="pro-list">Manage Structure</p>
                    //                         <p className="pro-list">Plan Expiry Behavior- 5 days Buffer</p>
                    //                     </div>
                    //                     <div className="freeplan-btn">
                    //                         <a onClick={handleOpen} target="blank" className="btn btn-freeplanset">Get started</a>
                    //                     </div>
                    //                     <div className="bg-set">
                    //                         <img src="assets/img/groupset.png" alt="img" className="bs-img1" />
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //             <div className="col-lg-4 col-sm-6 col-12 d-flex">
                    //                 <div className="freeplan plus-plan text-dark bg-warning flex-fill position-relative">
                    //                     <div className="recom-price">Recommended</div>
                    //                     <div className="freeplan-set mb-1">
                    //                         <div className="card-body sv-freeplan  rounded mb-3">
                    //                             <div className="d-flex align-items-center mb-2">
                    //                                 <div style={{ background: "#047EFF" }} className=" text-white p-2 rounded me-2 d-flex align-items-center justify-content-center" >
                    //                                     <i className='fa fa-star' /><i className='fa fa-star' /><i className='fa fa-star' />
                    //                                 </div>
                    //                                 <h3 className="mb-0 fw-bold text-dark">Yearly Plan</h3>
                    //                             </div>
                    //                             <hr className='text-dark' />
                    //                             <h2 style={{ fontSize: "40px" }} className="d-flex m-0 align-items-center fw-bold text-dark">₹500
                    //                                 <small className=' discount-title'>(20% off)</small>
                    //                             </h2>
                    //                         </div>
                    //                         <p>Include : </p>
                    //                         <p className="pro-list">Team limit - No Limit</p>
                    //                         <p className="pro-list">Admin Access - 4 Admin</p>
                    //                         <p className="pro-list">Features - All feature</p>
                    //                         <p className="pro-list">Invoice - included </p>
                    //                         <p className="pro-list">Manage Policy</p>
                    //                         <p className="pro-list">Manage Structure</p>
                    //                         <p className="pro-list">Plan Expiry Behavior- 7 days Buffer</p>
                    //                     </div>
                    //                     <div className="freeplan-btn">
                    //                         <a onClick={handleOpen} target="blank" className="btn btn-freeplanset">Get started</a>
                    //                     </div>
                    //                     <div className="bg-set">
                    //                         <img src="assets/img/groupset.png" alt="img" className="bs-img1" />
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         </React.Fragment>
                     }
                </div>
            </div>
        </div>
    )
}

export default Pricing
